module.exports = __webpack_public_path__ + "img/enrich_money_logo.a444d4e1.jpg";